import script from "./PdfPreviewMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./PdfPreviewMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./PdfPreviewMolecule.vue?vue&type=style&index=0&id=935c4642&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-935c4642"]])

export default __exports__